import * as React from 'react';
import { convertPixelsToRem } from '../../../../helpers';
//import { makeStyles } from '@mui/styles';
import {
  TableContainer,
  TableHead,
  TableRow,
  Table,
  TableBody,
  TableCell,
  TextField,
} from '@mui/material';
import { withStyles } from '@mui/styles';

const VariablesTable = (props) => {
  const tableUnlocked = props.status !== "SUCCESSFUL";
  // used to setup styles for containers and tables
  // const useStyles = makeStyles({
  //   container: {
  //     borderRight: '1px solid #797979',
  //     fontSize: `${convertPixelsToRem(12)} !important`,
  //   },
  //   table: {
  //     minWidth: 650,
  //   },
  // });

  // used to setup styles for table rows
  const StyledTableRow = withStyles((theme) => ({
    root: {
      '&.Mui-selected, &.Mui-selected:hover': {
        backgroundColor: '#eff2f8',
      },
    },
  }))(TableRow);

  // used to setup styles for long text fields
  const LongTextField = withStyles((theme) => ({
    root: {
      width: '90%',
      '& .MuiInputBase-root': {
        height: 20,
        fontSize: `${convertPixelsToRem(12)} !important`,
      },
    },
  }))(TextField);

  const handleTextfieldChange = async (e, id, column, props) => {
    // let newVariables = [...props.selectedStation.variables];
    // newVariables[variableIndex].value = e.target.value;
    props.handleTextfieldChange(e, id, column, props);
    // e, cbIdx, column, props
  };

  const GetField = (variable, column, id) => {
    return (
      <LongTextField
        defaultValue={variable[column]}
        variant="outlined"
        onBlur={(e) => handleTextfieldChange(e, id, column, props)}
      />
    );
  };

  console.log("selectedStation=", props.selectedStation)

  return (
    <TableContainer className="hideScrollbar" style={{ height: 500 }}>
      <Table sx={{ width: 650 }} stickyHeader aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center" style={{padding: 8}}>
              <b>
                NAME
              </b>
            </TableCell>
            <TableCell align="center" style={{padding: 8}}>
              <b>
                VALUE
              </b>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.selectedStation
            ? props.selectedStation.variables.map((variable, id) => {
                return (
                  <StyledTableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={`variable-${id}`}
                    style={{ height: 41 }}
                  >
                    <TableCell
                      align={'center'}
                      key='name'
                      style={{
                        paddingTop: 10,
                        paddingBottom: 10,
                        paddingRight: 0,
                        paddingLeft: 0,
                      }}
                    >
                      {variable.name}
                    </TableCell>

                    <TableCell
                      align={'center'}
                      key='value'
                      style={{
                        paddingTop: 10,
                        paddingBottom: 10,
                        paddingRight: 0,
                        paddingLeft: 0,
                        width: "50%",
                      }}
                    >
                      {tableUnlocked
                        ? GetField(variable, 'value', id)
                        : variable.value
                      }
                    </TableCell>

                  </StyledTableRow>
                );
              })
            : null}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default VariablesTable;
